var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFancyCheck = function SvgFancyCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5.04a12.5 12.5 0 0 0-3.157.15 5.5 5.5 0 0 0-2.126.868c-.66.467-2.158 1.937-3.012 2.905-.853.968-1.481 1.67-3.156 3.874a302 302 0 0 0-4.317 5.844c-1.755 2.438-2.69 3.607-2.947 3.607-.435 0-.693-.618-.934-1.82-.097-.535-.194-.969-.258-1.286-.354-1.92-1.401-1.47-2.287-1.085-1.192.484-1.933 1.736-1.788 3.055.032.334 0 .184.177 1.57.016.116.322 2.47.467 3.122.113.551.274 1.085.516 1.603.193.418.483.802.853 1.069.387.25.838.4 1.305.45 1.417.184 2.368-.367 3.865-2.154z"
  })));
};
export default SvgFancyCheck;